import React, { Component } from "react";
import { Link } from "react-router-dom";
export class NotificationsSearch extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      openDrawer: false,
    };
    this.fields = [
      {
        name: "name",
        label: "Notification Name",
        type: "text",
        placeholder: "Notification Name",
      },
      {
        name: "startDate",
        label: "Start Date",
        type: "date",
        placeholder: "Start Date",
      },
      {
        name: "endDate",
        label: "End Date",
        type: "date",
        placeholder: "End Date",
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: [],
        placeholder: "Status",
      },
    ];
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    return (
      <>
        <div className="d-flex align-items-center justify-content-end">
          <button
            type="button"
            className="btn filter_modal_btn"
            onClick={(...args) => this.toggleDrawer(...args)}
          >
            <i class="fa-solid fa-filter me-2"></i>
            <span>Filters</span>
          </button>
          <AppDynamicFilterModal
            open={openDrawer}
            onClose={this.closeDrawer}
            fields={this.fields}
            onSearch={this.onSearch}
            onReset={this.onReset}
          />
        </div>
        <div className="digi-vertical-line"></div>
        <Link
          to={"#"}
          className="btn btn-primary add_digi_team_member_btn ms-2"
          onClick={(...args) => this.props.onAddModalFields(...args)}
        >
          + Add New
        </Link>
      </>
    );
  }
}

export default constore(NotificationsSearch);
